// extracted by mini-css-extract-plugin
export default {"root":"Access__root--2MLtM","responsive":"Access__responsive--2vnyN","marginRight":"Access__marginRight--2xSo6"};